import React, { useRef, useEffect, useCallback } from 'react';
import './services.css';
import buffet from '../../assets/buffet.jpg';
import jacuzzi from '../../assets/jacuzzi.jpg';
import spa from '../../assets/spa.jpg';
import bdsm from '../../assets/bdsm.png';

const slides = [
    {
        img: buffet,
        title: 'Buffet & Drinks',
        desc: 'A generous spread for slow arrivals, long talks, and late-night cravings.',
    },
    {
        img: jacuzzi,
        title: 'Jacuzzi Lounge',
        desc: 'Warm water, low light, and a calm private setting built for unwinding.',
    },
    {
        img: spa,
        title: 'Spa Rituals',
        desc: 'Massage-ready comfort that turns the booking into a full escape.',
    },
    {
        img: bdsm,
        title: 'Fantasy Room',
        desc: 'A discreet, adult-only space for bolder private experiences.',
    },
];

const Services = () => {
    const nextDom = useRef(null);
    const prevDom = useRef(null);
    const carouselDom = useRef(null);
    const listItemDom = useRef(null);
    const thumbnailDom = useRef(null);
    const runTimeOut = useRef(null);
    const runAutoRun = useRef(null);

    const showSlider = useCallback((type) => {
        const itemSlider = document.querySelectorAll('.carousel .list .item');
        const itemThumbnail = document.querySelectorAll('.carousel .thumbnail .item');

        if (!carouselDom.current || !listItemDom.current || !thumbnailDom.current || !itemSlider.length || !itemThumbnail.length) {
            return;
        }

        if (type === 'next') {
            listItemDom.current.appendChild(itemSlider[0]);
            thumbnailDom.current.appendChild(itemThumbnail[0]);
            carouselDom.current.classList.add('next');
        } else {
            const positionLastItem = itemSlider.length - 1;
            listItemDom.current.prepend(itemSlider[positionLastItem]);
            thumbnailDom.current.prepend(itemThumbnail[positionLastItem]);
            carouselDom.current.classList.add('prev');
        }

        clearTimeout(runTimeOut.current);
        runTimeOut.current = setTimeout(() => {
            carouselDom.current.classList.remove('next');
            carouselDom.current.classList.remove('prev');
        }, 3000);

        clearTimeout(runAutoRun.current);
        runAutoRun.current = setTimeout(() => showSlider('next'), 7000);
    }, []);

    useEffect(() => {
        runAutoRun.current = setTimeout(() => showSlider('next'), 7000);
        return () => {
            clearTimeout(runTimeOut.current);
            clearTimeout(runAutoRun.current);
        };
    }, [showSlider]);

    return (
        <section className='services fade-section' id='services'>
            <div className="services__header">
                <p className="services__eyebrow">Included in the booking</p>
                <h2 className="services__title">The Lounge Experience</h2>
                <p className="services__subtitle">Four moods, one private escape.</p>
            </div>
            <div ref={carouselDom} className="carousel">
                <div ref={listItemDom} className="list">
                    {slides.map((slide, index) => (
                        <div className="item" key={index}>
                            <img src={slide.img} alt={slide.title} />
                            <div className="item__gradient"></div>
                            <div className="item__label">
                                <div className="item__label-title">{slide.title}</div>
                                <div className="item__label-desc">{slide.desc}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <div ref={thumbnailDom} className="thumbnail">
                    {[slides[1], slides[2], slides[3], slides[0]].map((slide, index) => (
                        <div className="item" key={index}>
                            <img src={slide.img} alt={slide.title} />
                        </div>
                    ))}
                </div>
                <div className="arrows">
                    <button id='prev' ref={prevDom} onClick={() => showSlider('prev')} aria-label="Previous slide">{String.fromCharCode(60)}</button>
                    <button id='next' ref={nextDom} onClick={() => showSlider('next')} aria-label="Next slide">{String.fromCharCode(62)}</button>
                </div>
                <div className="time"></div>
            </div>
        </section>
    )
}

export default Services
